import { LLMConfig } from '../../AIChat/types';

export type PortfolioTier = 'standard' | 'grand_cru' | 'cult_cru' | 'black_cru';

interface TierThreshold {
  tier: PortfolioTier;
  minValue: number;
}

const TIER_THRESHOLDS: TierThreshold[] = [
  { tier: 'black_cru', minValue: 1_000_000 },
  { tier: 'cult_cru', minValue: 500_000 },
  { tier: 'grand_cru', minValue: 100_000 },
  { tier: 'standard', minValue: 0 },
];

export const getPortfolioTier = (value: number): PortfolioTier => {
  for (const { tier, minValue } of TIER_THRESHOLDS) {
    if (value >= minValue) return tier;
  }
  return 'standard';
};

const TIER_CONFIG: Record<PortfolioTier, Partial<LLMConfig>> = {
  standard: {
    temperature: 0.5,
    maxTokens: 2048,
  },
  grand_cru: {
    temperature: 0.4,
    maxTokens: 3072,
  },
  cult_cru: {
    temperature: 0.3,
    maxTokens: 4096,
  },
  black_cru: {
    temperature: 0.3,
    maxTokens: 4096,
  },
};

export const getTierConfigOverride = (tier: PortfolioTier): Partial<LLMConfig> => {
  return TIER_CONFIG[tier] || TIER_CONFIG.standard;
};

export const TIER_DISPLAY_NAMES: Record<PortfolioTier, string> = {
  standard: 'Standard',
  grand_cru: 'Grand Cru',
  cult_cru: 'Cult Cru',
  black_cru: 'Black Cru',
};
